import Component from '@/scripts/core/Component';
import ImageCropperComponent from '@/scripts/vue/components/ImageCropper.vue';

class ImageCropper extends Component {
  onInit() {
    const {
      values,
      label,
      maxFileSize,
      ratio,
      imageWidth,
      imageHeight,
      mimeTypes,
      thumb,
    } = this.$props;

    this.cropper = this.$initVueComponent({
      render(h) {
        return h(ImageCropperComponent, {
          props: {
            values,
            label,
            maxFileSize,
            ratio,
            imageWidth,
            imageHeight,
            mimeTypes,
            thumb,
          },
          on: {
            add: (e) => {
              this.$emit('add', e);
            },
            remove: () => {
              this.$emit('remove');
            },
          },
        });
      },
    });
  }

  onDestroy() {
    if (this.cropper) {
      this.cropper.$destroy();
      this.cropper.$el.parentElement.removeChild(this.cropper.$el);
      this.cropper = null;
    }
  }
}

export default ImageCropper;
